import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent {
  //incoterns = ['EXW', 'FCA', 'CPT', 'CIP', 'DPU', 'DAP', 'DDP', 'FAS', 'FOB', 'CFR', 'CIF'];
  incoterms = {
    EXW: 'ExWorks',
    FCA: 'Free Carrier',
    CPT: 'Carriage Paid To',
    CIP: 'Carriage and Insurance Paid To',
    DPU: 'Delivered at Place Unloaded',
    DAP: 'Delivered at Place',
    DDP: 'Delivered Duty Paid',
    FAS: 'Free Alongside Ship',
    FOB: 'Free on Board',
    CFR: 'Cost and Freight',
    CIF: 'Cost, Insurance and Freight',
    DDU: 'Delivered Duty Unpaid',
  };
  uoms = {
    imperial: '(IN/LB)',
    metric: '(KG/CM) ',
  };
  @Input() shipmentForm: FormGroup;
}
